import {
    FETCH_ADDRESS_TYPES,
} from '../../mutation-types';

export default {
  [FETCH_ADDRESS_TYPES](state, addressTypes) {
    state.addressTypes = addressTypes;
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/addressTypes/mutations.js